import { render, staticRenderFns } from "./automatedAssessmentDashboard.vue?vue&type=template&id=4eebb8a5&scoped=true"
import script from "./automatedAssessmentDashboard.vue?vue&type=script&lang=js"
export * from "./automatedAssessmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./automatedAssessmentDashboard.vue?vue&type=style&index=0&id=4eebb8a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eebb8a5",
  null
  
)

export default component.exports